{
  "hero": {
    "title": "Verwandeln Sie Ihren Produktkatalog in",
    "subtitle": "KI-Einkaufsberater",
    "description": "Setzen Sie Verkaufskräfte ein, die verkaufen — nicht nur chatten. Auf Ihrer Website, in sozialen Medien, WhatsApp und ChatGPT.",
    "createAssistant": "KI-Assistent erstellen",
    "bookDemo": "Demo buchen"
  },
  "nav": {
    "solutions": "Lösungen",
    "products": "Produkte",
    "pricing": "Preise",
    "caseStudies": "Fallstudien",
    "blog": "Blog",
    "contact": "Kontakt",
    "shoppingExpert": "Einkaufsexperte",
    "gptStore": "GPT Store"
  },
  "chat": {
    "greeting": "Hallo! Ich bin Ihr KI-Einkaufsassistent. Fragen Sie mich nach Produkten wie Fernsehern, Laptops oder Kaffeemaschinen. Wie kann ich Ihnen heute helfen?",
    "placeholder": "Geben Sie Ihre Nachricht hier ein...",
    "contact": {
      "heading": "Bitte teilen Sie Ihre Kontaktinformationen mit"
    }
  },
  "sections": {
    "partners": {
      "title": "Vertraut von führenden Plattformen"
    },
    "gptPromo": {
      "title": "Bringen Sie Ihre Marke in den GPT Store",
      "description": "Erstellen Sie einen benutzerdefinierten GPT-Einkaufsassistenten, der Ihre Produkte präsentiert und Besucher in Käufer verwandelt."
    },
    "solutions": {
      "title": "Branchenlösungen",
      "subtitle": "KI-Einkaufsberater, die auf Ihre Branche zugeschnitten sind",
      "electronics": {
        "title": "Elektronik & Technik",
        "description": "Helfen Sie Kunden, komplexe technische Daten zu navigieren und das perfekte Gerät zu finden.",
        "items": [
          "Intelligente Produktvergleiche",
          "Technische Spezifikationsabgleiche",
          "Kompatibilitätsprüfung",
          "Leistungsempfehlungen"
        ]
      },
      "fashion": {
        "title": "Mode & Bekleidung",
        "description": "Bieten Sie personalisierte Styling-Beratung und Größenempfehlungen.",
        "items": [
          "Stil-Matching und Empfehlungen",
          "Größen- und Passformberatung",
          "Saisonale Trendberatung",
          "Outfit-Koordination"
        ]
      },
      "home": {
        "title": "Haus & Garten",
        "description": "Führen Sie Kunden durch Heimwerker- und Dekorationsentscheidungen.",
        "items": [
          "Raumgestaltungsberatung",
          "Geräteempfehlungen",
          "Raumoptimierungsberatung",
          "Wartungsanleitungen"
        ]
      },
      "agency": {
        "title": "Agenturen & Partner",
        "description": "White-Label-Lösungen für Agenturen, die mehrere Einzelhandelskunden betreuen.",
        "items": [
          "Multi-Client-Management",
          "Individuelle Branding-Optionen",
          "Analysen und Berichte",
          "Agenturpartner-Support"
        ]
      }
    },
    "platforms": {
      "title": "Unterstützte Plattform"
    },
    "valueProps": {
      "title": "Warum Shopilots wählen?",
      "subtitle": "Transformieren Sie Ihr Einzelhandelserlebnis mit KI, die tatsächlich verkauft",
      "conversion": {
        "title": "Konversionen steigern",
        "description": "Verwandeln Sie Besucher in Käufer mit personalisierten Produktempfehlungen und geführten Einkaufserlebnissen.",
        "metric": "Konversionsrate"
      },
      "aov": {
        "title": "Durchschnittswert erhöhen",
        "description": "Intelligente Upselling- und Cross-Selling-Vorschläge, die sich für Kunden natürlich und hilfreich anfühlen.",
        "metric": "Durchschnittlicher Bestellwert"
      },
      "returns": {
        "title": "Retouren reduzieren",
        "description": "Bessere Produktübereinstimmung bedeutet, dass Kunden beim ersten Mal genau das bekommen, was sie brauchen.",
        "metric": "Retourenquote"
      },
      "advantage": {
        "title": "Der Shopilots-Vorteil",
        "description": "Im Gegensatz zu generischen Chatbots versteht unsere KI Ihre Produkte und spricht mit Ihrer Markenstimme.",
        "features": {
          "catalog": "Echtzeit-Katalogintegration",
          "sales": "Verkaufsorientierte Gespräche",
          "channels": "Multi-Channel-Einsatz",
          "analytics": "Umsatzorientierte Analysen"
        }
      },
      "testimonial": {
        "title": "Kundenerfolg",
        "quote": "Shopilots hat unseren Online-Verkauf transformiert. Kunden finden Produkte schneller und kaufen mit mehr Vertrauen.",
        "name": "Sarah Johnson",
        "position": "E-Commerce-Direktorin"
      }
    }
  },
  "micro": {
    "demoMode": "Demo-Modus"
  },
  "forms": {
    "name": "Name",
    "email": "E-Mail",
    "company": "Unternehmen",
    "phone": "Telefon",
    "optional": "optional",
    "thankYou": "Vielen Dank!"
  },
  "buttons": {
    "sending": "Wird gesendet...",
    "submit": "Absenden",
    "launchAssistant": "Starten Sie Ihren KI-Assistenten",
    "callUs": "Rufen Sie uns an",
    "learnMore": "Mehr erfahren",
    "getStarted": "Loslegen",
    "findSolution": "Finden Sie Ihre Lösung"
  },
  "footer": {
    "description": "KI-Einkaufsberater, die verkaufen — nicht nur chatten. Einsetzbar auf Ihrer Website, in sozialen Medien, WhatsApp und ChatGPT.",
    "solutions": "Lösungen",
    "resources": "Ressourcen",
    "contactUs": "Kontaktieren Sie uns",
    "copyright": "Alle Rechte vorbehalten.",
    "links": {
      "privacyPolicy": "Datenschutzrichtlinie",
      "termsOfService": "Nutzungsbedingungen",
      "sitemap": "Sitemap"
    }
  }
}